<template>
    <div class="body back-gray">
        <div class="wrap txt-center end">
            <img src="../../assets/images/test_end.png" alt="">
            <h1 class="mt-20">
                SPAC^ Writing TEST가<br>완료되었습니다.
            </h1>
        </div>

        <div class="wrap">
            <div class="btn-fixed"><button class="btn-full" @click="end()">확인</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'TestStart',
    components: {
        Footer
    },
    data: () => ({
        
    }),
    mounted() {
       
    },
    methods: {
        end(){
            // this.$route.push("/intro");
            location.href = '/intro';
        }

    }
}
</script>